"use strict";

const consentLinks = document.querySelectorAll('.cookie-consent-preferences');
consentLinks?.forEach((el)=> 
    el.addEventListener('click',() => {
        window.showCookieSettings()
    })
)